/**
 * Which topic a query is about.
 *
 * ORDER IS THE ALGORITHM. This is a first-match-wins substring scan, not a
 * scorer: "email the invoice" is classified `contacts`, because the contacts
 * branch tests `email` and runs before the quickbooks branch. That is a tuning
 * outcome, not a defect — but it means reordering these branches silently
 * changes retrieval for a whole class of questions with nothing to notice it.
 * `tests/lib/rag/query-enhancer.test.ts` pins the precedence for that reason.
 */

import type { QueryTopic } from './keywords';

/**
 * Detect the primary topic of a query
 */
export function detectQueryTopic(query: string): QueryTopic | null {
  const lowerQuery = query.toLowerCase();

  if (
    lowerQuery.includes('deal') ||
    lowerQuery.includes('pipeline') ||
    lowerQuery.includes('sales') ||
    lowerQuery.includes('follow up') ||
    lowerQuery.includes('follow-up')
  ) {
    return 'sales';
  }
  if (
    lowerQuery.includes('ticket') ||
    lowerQuery.includes('support') ||
    lowerQuery.includes('escalat') ||
    lowerQuery.includes('resolution')
  ) {
    return 'tickets';
  }
  if (
    lowerQuery.includes('contact') ||
    lowerQuery.includes('log ') ||
    lowerQuery.includes('meeting') ||
    lowerQuery.includes('call') ||
    lowerQuery.includes('email') ||
    lowerQuery.includes('activity')
  ) {
    return 'contacts';
  }
  if (
    lowerQuery.includes('operation') ||
    lowerQuery.includes('process') ||
    lowerQuery.includes('workflow') ||
    lowerQuery.includes('msp')
  ) {
    return 'operations';
  }
  if (
    lowerQuery.includes('quickbooks') ||
    lowerQuery.includes('invoice') ||
    lowerQuery.includes('billing') ||
    lowerQuery.includes('customer balance')
  ) {
    return 'quickbooks';
  }
  if (lowerQuery.includes('strategy') || lowerQuery.includes('plan') || lowerQuery.includes('approach')) {
    return 'operations';
  }

  return null;
}
